import { StatusBadge } from '../../../components/common/StatusBadge';
import {
  experimentStatusMeta,
  runStatusMeta,
  spotlightStatusMeta,
} from '../statusConfig';

export function SpotlightStatusBadge({
  status,
  className,
}: {
  status: string;
  className?: string;
}) {
  const meta = spotlightStatusMeta(status);
  return (
    <StatusBadge
      status={meta.label}
      variant={meta.variant}
      className={className}
    />
  );
}

export function ExperimentStatusBadge({
  status,
  className,
}: {
  status: string;
  className?: string;
}) {
  const meta = experimentStatusMeta(status);
  return (
    <StatusBadge
      status={meta.label}
      variant={meta.variant}
      className={className}
    />
  );
}

export function RunStatusBadge({
  status,
  className,
}: {
  status: string;
  className?: string;
}) {
  const meta = runStatusMeta(status);
  return (
    <StatusBadge
      status={meta.label}
      variant={meta.variant}
      className={className}
    />
  );
}
